import { apiAction } from 'client/redux/apiHelpers';

export const endpointBankidRead = (types, id) => {
  return apiAction({
    endpoint: `/api/endpoint/bankid/${id}`,
    method: 'GET',
    types,
  });
};

export const endpointBankidEditSettings = (type, isEditing) => {
  return {
    type,
    isEditing,
  };
};

export const endpointBankidUpdateSettings = (types, id, settings) => {
  return apiAction({
    endpoint: `/api/endpoint/bankid/${id}/settings`,
    method: 'PATCH',
    types,
    json: settings,
  });
};
